import { render } from "./성형외과.vue?vue&type=template&id=51c3fd50"
import script from "./성형외과.vue?vue&type=script&lang=js"
export * from "./성형외과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__